<template>
  <div class="approval-model-detail">
    <div class="btn-control">
      <el-button @click=cancelClick>{{ $t('取消') }}</el-button>
      <el-button @click="saveModel">{{ $t('保存') }}</el-button>
    </div>
    <div class="model-content">
      <div class="model-flow-chart">
        <div class="chart">
          <div class="flow-cart approve-cart" @click="addApproveDetail('start', null)">
            <p>{{ $t('发起') }}</p>
            <p>{{ $t('审批流程开始') }}</p>
            <span class="icon"></span>
            <span class="border-line"></span>
          </div>

          <div class="flow-cart approve-cart" v-for="(obj, i) in approveList" :key="i"
            @click="addApproveDetail('middle', i)">
            <p class="title-flex">{{ obj.name }}</p>
            <p>{{ $t('添加审批方式') }}</p>
            <span class="icon"></span>
            <span class="border-line"></span>
            <i v-show="i === 0" class="el-icon-circle-plus-outline public-icon" style="font-size: 28px; cursor: pointer;"
              @click.stop="addApproveStep"></i>
            <i v-show="i === approveList.length - 1 && i !== 0" class="el-icon-remove-outline public-icon"
              style="font-size: 28px; cursor: pointer;" @click.stop="removeApproveStep(i)"></i>
          </div>

          <div class="flow-cart">
            <p>{{ $t('结束') }}</p>
            <p>{{ $t('审批流程结束') }}</p>
          </div>
        </div>
      </div>
      <div class="model-detail" v-if="contentStatus === 'start'">
        <div class="title">
          <span>{{ $t('发起') }}</span>
          <span class="icon" @click="closeModel"></span>
        </div>
        <div class="content">
          <el-form :model="initiateApproval" label-position="top">
            <el-form-item :label="$t('允许审批撤回')">
              <el-radio-group v-model="initiateApproval.canWithdraw">
                <el-radio :label="1">{{ $t('允许') }}</el-radio>
                <el-radio :label="0">{{ $t('不允许') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('PKI认证（pki开启后只能在com环境使用）')">
              <el-radio-group v-model="initiateApproval.usePki">
                <el-radio :label="1">{{ $t('开启') }}</el-radio>
                <el-radio :label="0">{{ $t('关闭') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('加签')">
              <el-radio-group v-model="initiateApproval.useSign">
                <el-radio :label="1">{{ $t('开启') }}</el-radio>
                <el-radio :label="0">{{ $t('关闭') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="model-detail" v-if="contentStatus === 'middle'">
        <div class="title">
          <span>{{ $t('审批设置') }}：{{ approveList[currentClickApproveStepIndex]['name'] }}</span>
          <span class="icon" @click="closeModel"></span>
        </div>
        <div class="content">
          <el-form :model="approvalUserInfo" label-position="top" class="approve-user-set">
            <el-form-item :label="$t('审批人设置')" prop="user">
              <div class="flex" v-for="(item, index) in approveList[currentClickApproveStepIndex]['userList']"
                :key="index">
                <el-input v-model="item.user" :placeholder="$t('请输入审批用户邮箱')" class="input"></el-input>
                <i v-show="index === 0" class="el-icon-circle-plus-outline" style="font-size: 28px; cursor: pointer;"
                  @click="addApproveUser"></i>
                <i v-show="index !== 0" class="el-icon-remove-outline" style="font-size: 28px; cursor: pointer;"
                  @click="removeApproveUser(index)"></i>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('提示')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="35%"
      :before-close="beforeClose">
      <p class="email-auth-tip">{{ this.noAuthEmail }}&nbsp;{{ $t('邮箱权限提示') }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeClose">{{ $t('取消') }}</el-button>
        <el-button type="primary" @click="sureEmail">{{ $t('仍然保存') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Ajax from '@/ajax';
export default {
  data () {
    return {
      dialogVisible: false,
      noAuthEmail: '',
      contentStatus: '',
      currentClickApproveStepIndex: 0,
      stepChangeFormat: {
        1: '1101',
        2: '1102',
        3: '1103'
      },
      initiateApproval: {
        canWithdraw: 0,
        usePki: 0,
        useSign: 0,
        // 1101 一级 1102 二级 1103 三级
        flowMode: '',
        // [[], [], []] 审批人
        approvers: []
      },
      approveStep: 1,
      approvalUserInfo: {
        user: ''
      },
      approveList: [
        // {
        //   name: '审批1',
        //   userList: [
        //     {
        //       user: ''
        //     }
        //   ]
        // }
      ]
    }
  },
  created () {
    this.queryParams = JSON.parse(decodeURIComponent(atob(this.$route.query.info)));
    try {
      Object.assign(this.initiateApproval, this.queryParams.data);
      this.initiateApproval.approvers = this.initiateApproval.approvers || [];
      if (this.initiateApproval.approvers.length) {
        this.initiateApproval.approvers.forEach((arr, i) => {
          this.approveList.push({
            name: this.$t('审批') + (i + 1),
            userList: []
          });
          arr.forEach(val => {
            this.approveList[i].userList.push({
              user: val
            });
          });
        });
      } else {
        // 初始化
        this.approveList = [
          {
            name: this.$t('审批') + 1,
            userList: [
              {
                user: ''
              }
            ]
          }
        ];
      }
      // 一共几级审批
      this.approveStep = this.approveList.length;
    } catch (error) {
      console.error(error);
    }

  },
  methods: {
    async saveModel () {
      let flag = true;
      const approvers = [];
      const emails = [];
      this.approveList.every(objF => {
        const arr = [];
        objF.userList.every(objC => {
          if (!objC.user) {
            flag = false;
            this.$message.warning(this.$t(objF.name) + ' ' + this.$t('中审批人邮箱不能为空'));
            return false;
          }
          if (!/@/.test(objC.user)) {
            flag = false;
            this.$message.warning(this.$t(objF.name) + ' ' + this.$t('中审批人邮箱格式不正确'));
            return false;
          }
          arr.push(objC.user);
          emails.push(objC.user);
          return true;
        });
        approvers.push(arr);
        return true;
      });
      // 邮箱填写正确后的逻辑
      if (flag) {
        // 设置 邮箱，审批层级
        this.initiateApproval.approvers = JSON.stringify(approvers);
        this.initiateApproval.flowMode = this.stepChangeFormat[this.approveList.length];
        // 验证邮箱是否有审批权限
        this.noAuthEmail = await this.emailAuth(emails);
        if (this.noAuthEmail) {
          this.dialogVisible = true;
          return;
        }
        // 如果邮箱都有权限 返回null 发起保存
        this.sureEmail();
      }
    },
    sureEmail () {
      Ajax({
        url: '/api/approve/biz/template/update',
        method: 'post',
        data: this.initiateApproval
      })
        .then(() => {
          this.$message.success(this.$t('执行成功'))
          this.$router.push({
            path: '/approval/approval_model'
          });
        })
        .catch((err) => {
          this.$message.error(err || this.$t('服务器开小差'))
          console.log(err)
        });
    },
    emailAuth (approvers) {
      return new Promise((resolve) => {
        Ajax({
          url: '/api/approve/role/verify',
          method: 'post',
          data: approvers
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      });
    },
    addApproveDetail (status, i) {
      this.contentStatus = status;
      if (i !== null) {
        this.currentClickApproveStepIndex = i;
      }
    },
    closeModel () {
      this.contentStatus = '';
    },
    addApproveUser () {
      if (this.approveList[this.currentClickApproveStepIndex]['userList'].length >= 5) {
        this.$message.warning(this.$t('每一级审批最多5人'));
        return;
      }
      this.approveList[this.currentClickApproveStepIndex]['userList'].push({ user: '' });
    },
    removeApproveUser (i) {
      this.approveList[this.currentClickApproveStepIndex]['userList'].splice(i, 1);
    },
    addApproveStep () {
      if (this.approveList.length > 2) {
        this.$message.warning(this.$t('审批最多三个层级'));
        return;
      }
      this.approveStep++;
      this.approveList.push({
        name: this.$t('审批') + this.approveStep,
        userList: [
          {
            user: ''
          }
        ]
      });
    },
    removeApproveStep (i) {
      // 如果删除的节点 正好是当前节点的审批设置弹窗 关闭它
      if (this.currentClickApproveStepIndex === i) {
        this.closeModel();
      }
      this.approveStep--;
      this.approveList.splice(i, 1);
    },
    cancelClick () {
      this.$router.push({
        path: '/approval/approval_model'
      });
    },
    beforeClose () {
      this.dialogVisible = false;
    }
  }
}
</script>
<style lang="scss" scoped>
.approval-model-detail {
  .btn-control {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    margin-bottom: 16px;
  }

  .model-content {
    min-height: 100%;
    padding-bottom: 16px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    display: flex;
  }

  .model-flow-chart {
    flex: .6;
    margin-right: 16px;
    display: flex;
    justify-content: center;
  }

  .model-detail {
    border: 1px solid #000;
    margin-top: 5px;
    border-radius: 5px;
    padding: 15px;
    flex: .4;

    .title {
      padding: 5px 0 12px 0;
      border-bottom: 1px solid #000;
      display: flex;
      justify-content: space-between;

      .icon {
        cursor: pointer;
        width: 20px;
        height: 20px;
        background: url('../../../assets/close-icon.png') no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }

  .flow-cart {
    width: 300px;
    height: 120px;
    padding: 15px;
    border-radius: 8px;
    background-color: #027DB4;
    margin-top: 50px;
    position: relative;

    p:nth-child(1) {
      color: #fff;
      padding-bottom: 10px;
    }

    p:nth-child(2) {
      color: #000;
      padding: 15px;
      text-align: center;
      border-radius: 10px;
      background-color: #fff;
    }

    .icon {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 20px;
      top: 56px;
      font-weight: 700;
      font-size: 25px;
      background: url('../../../assets/right-icon.png') no-repeat center center;
      background-size: 100% 100%;
    }

    .border-line {
      width: 2px;
      height: 50px;
      position: absolute;
      left: 150px;
      top: 120px;
      background-color: #e5e5e5;
    }

    .public-icon {
      position: absolute;
      left: 137px;
      top: 132px;
    }
  }

  .approve-cart {
    p:nth-child(2) {
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.model-detail {
  .content {
    .el-form-item__label {
      padding: 0;
      height: 35px;
    }
  }

  .approve-user-set {
    .flex {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;

      .input {
        margin-right: 15px;
      }
    }
  }
}

.email-auth-tip {
  line-height: 26px;
}
</style>
